import { render, staticRenderFns } from "./ndr_mr.vue?vue&type=template&id=7772f96c&"
import script from "./ndr_mr.vue?vue&type=script&lang=js&"
export * from "./ndr_mr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports